import { constants } from "@newsela/angelou";

const uiColors = constants.colors.ui;

export const annotationCss = {
  color: uiColors.neutral[600],
};

export const indicatorContainerCss = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "16px",
};
